import classNames from 'classnames'

import type { TextProps } from '@/shared/components/typography/Title'

import { levels, colors, weights, styles, aligns } from '@/styles/shared/typography'

const Caption = ({ level, color, weight, align, children, style, className }: TextProps) => {
  return (
    <span
      className={classNames(
        levels[level],
        color ? colors[color] : '',
        weight ? weights[weight] : '',
        align ? aligns[align] : '',
        style ? styles[style] : '',
        className
      )}
    >
      {children}
    </span>
  )
}

export default Caption
